import React from 'react';
import DicomViewer from './components/DicomViewer';

const App = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <DicomViewer />
    </div>
  );
};

export default App;
